import type { Coords } from '../../../common/types';
import { coordinatesToCoords } from '../../../common/utils';
import type { ChargingStationMetadata, Coordinates } from '../../facade/facadeApiV3';
import { sendMessage } from '../widgetServices';
import { widgetActions } from '../widgetSlice';

export const CS_MARKER_TYPE = 'chargingStation';

export type RenderStationsPayload = {
    chargingStations: MapChargingStation[];
};

export class MapChargingStation {
    constructor(
        public id: string,
        public stationId?: string,
        public data?: {
            enableContextMenu?: boolean;
            contextMenuMarkerName?: string;
            markerType?: string;
            lat?: number;
            lng?: number;
        },
        public markerProps?: {
            name?: string;
        },
        public position?: Coords
    ) {}
}

export class MapStationBuilder {
    private id!: string;
    private name!: string;
    private stationId!: string;
    private location!: Coordinates;
    private readonly enableContextMenu!: boolean;
    private readonly contextMenuMarkerName!: string;
    private readonly markerType!: string;

    constructor() {
        this.enableContextMenu = true;
        this.contextMenuMarkerName = 'ChargingStation ContextMenu';
        this.markerType = CS_MARKER_TYPE;
    }

    withId(id: string) {
        this.id = id;
        return this;
    }

    withName(name: string) {
        this.name = name;
        return this;
    }

    withLocation(location: Coordinates) {
        this.location = location;
        return this;
    }

    build(): MapChargingStation {
        const data = {
            stationId: this.stationId,
            enableContextMenu: this.enableContextMenu,
            contextMenuMarkerName: this.contextMenuMarkerName,
            markerType: this.markerType,
            lat: this.location.latitude,
            lng: this.location.longitude,
            station_id: this.id,
        };

        const markerProps = {
            name: this.name,
        };

        const position = coordinatesToCoords(this.location);

        return new MapChargingStation(this.id, this.id, data, markerProps, position);
    }
}

export const renderChargingPoints = (stations: MapChargingStation[]) => {
    sendMessage(widgetActions.renderChargingPoints({ chargingStations: stations }));
};

export const renderChargingPointsWithStations = (stations: ChargingStationMetadata[]) => {
    const mapStations = stations
        .filter((station): station is ChargingStationMetadata & { id: string; name: string; location: Coordinates } =>
            Boolean(station?.id && station?.name && station?.location)
        )
        .map(station =>
            new MapStationBuilder().withId(station.id).withName(station.name).withLocation(station.location).build()
        );
    renderChargingPoints(mapStations);
};
